module.exports = __webpack_public_path__ + "img/image23.342dac53.png";